export default "__VITE_ASSET__211683e5__"